<div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/opportunities-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Oportunidades</h3>
            </div>
            <div class="justify-self-end">
                <button class="action-btn primary" (click)="openMdlCreateOportunity()">
                    Crear nueva oportunidad
                </button>
            </div>
        </div>
        <div class="header-stats mt-2">
      <span>{{oportunidades.length}} elementos | Se actualizó hace 2 minutos</span>
    </div>
    <div class="prospectos-table mt-4">
      <table>
        <thead>
          <tr>
            <th class="checkbox-column text-center">
              <img src="assets/svg/checkline-icon.svg" />
            </th>
            <th>Nombre oportunidad</th>
            <th>Estado</th>
            <th>Monto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of oportunidades">
            <td class="checkbox-column">
              <input type="checkbox" (click)="$event.stopPropagation()" />
            </td>
            <td>{{ c.nombre }}</td>
            <td>{{ c.estado?.nombre || '-' }}</td>
            <td>{{ c.importe_actual || '-' }}</td>
            <div class="dropdown-container">
              <button class="dots-button">
                <svg class="dots-icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="19" r="2" />
                </svg>
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item">Modificar</button>
                <button class="dropdown-item">Eliminar</button>
                <button class="dropdown-item">Cambiar propietario</button>
                <button class="dropdown-item">Modificar etiquetas</button>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
        <div class="contact-table-footer text-center">
      <button class="btn-primary-outline-2">Ver todas las oportunidades</button>
    </div>

    </div>

    <div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/money-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Presupuestos</h3>
            </div>
            <div class="justify-self-end">
                <button class="action-btn primary" (click)="openMdlCreateBudget()">
                    Crear nuevo presupuesto
                </button>
            </div>
        </div>
    <div class="header-stats mt-2">
      <span>{{presupuestos.length}} elementos | Se actualizó hace 2 minutos</span>
    </div>
    <div class="prospectos-table mt-4">
      <table>
        <thead>
          <tr>
            <th class="checkbox-column text-center">
              <img src="assets/svg/checkline-icon.svg" />
            </th>
            <th>Nombre presupuesto</th>
            <th>Fecha caducidad</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of presupuestos">
            <td class="checkbox-column">
              <input type="checkbox" (click)="$event.stopPropagation()" />
            </td>
            <td>{{ p.nombre_presupuesto }}</td>
            <td>{{ p.fecha_caducidad || '-' }}</td>
            <td>{{ p.precio_total || '-' }}</td>
            <div class="dropdown-container">
              <button class="dots-button">
                <svg class="dots-icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="19" r="2" />
                </svg>
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item">Modificar</button>
                <button class="dropdown-item">Eliminar</button>
                <button class="dropdown-item">Cambiar propietario</button>
                <button class="dropdown-item">Modificar etiquetas</button>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
        <div class="contact-table-footer text-center">
      <button class="btn-primary-outline-2">Ver todos los presupuestos</button>
    </div>
    </div>

    <div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/stories-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Casos</h3>
            </div>
            <div class="justify-self-end">
                <button class="action-btn primary">
                    Crear nuevo caso
                </button>
            </div>
        </div>
    </div>